module.exports = __webpack_public_path__ + "static/media/valor3_1.49d0ee21.png";